angular.module('tuitionFeesModule')
    .component('invoiceDetailViewPayments', {
        bindings: {
            invoicePayments: '<',
            paymentMethods: '<'
        },
        templateUrl: '/Scripts/app/tuitionFees/components/invoice/invoice-detail-view-payments.template.html',
        controller: class InvoiceDetailViewPaymentsCtrl {

            // bindings
            invoicePayments: any[];
            paymentMethods: any[];

            // dependencies
            $window: any;
            invoiceService: any;

            // variables
            currencyDisplaySymbol: string;
            currencyExponent: number;
            showNoResult: boolean;
            sortReverse: boolean = true;
            sortType: string = 'datePaid';
            downloadingReceiptId: number | null = null;

            static $inject = ['$window', 'invoiceService'];

            constructor($window, invoiceService) {
                this.$window = $window;
                this.invoiceService = invoiceService;
                this.showNoResult = false;

                this.currencyDisplaySymbol = $window.EveryBuddy.Constants.CurrencyDisplaySymbol;
                this.currencyExponent = $window.EveryBuddy.Constants.CurrencyExponent;
            }

            $onChanges(changes) {
                if (changes.invoicePayments?.currentValue) {
                    this.showNoResult = !changes.invoicePayments?.currentValue || changes.invoicePayments?.currentValue?.length == 0;
                }
            }

            getPaymentMethodName(paymentMethodId: number) : string {
                var paymentMethod = this.paymentMethods.find(x => x.id == paymentMethodId);
                if (paymentMethod) {
                    return paymentMethod.name;
                }

                return '';
            }

            // Each successful download writes an OrganisationPDFAudit row, so a double click
            // must not fire a second request (SB-16454).
            downloadReceipt(item) {
                if (this.downloadingReceiptId !== null || !item?.pdfBlobPath) {
                    return;
                }

                this.downloadingReceiptId = item.id;
                this.invoiceService.downloadPdf(item.pdfBlobPath, `Receipt-${item.id}.pdf`)
                    .finally(() => {
                        this.downloadingReceiptId = null;
                    });
            }
        }
    });
